// Module-level mutable trace log for cross-component diagnostics.
// Survives re-renders, unmounts, and React Router transitions because it
// lives outside React state. Read at render time by AuthProfileDialog and
// any other diagnostic surface.
//
// Not persisted across full page reloads — that's intentional, so each
// fresh session starts clean.

export const traceLog: { ts: number; tag: string; detail: string }[] = [];

export function addTrace(tag: string, detail = '') {
    const ts = typeof performance !== 'undefined' ? performance.now() : Date.now();
    traceLog.push({ ts, tag, detail });
    if (traceLog.length > 200) traceLog.shift(); // cap to keep memory bounded
}

export function clearTrace() {
    traceLog.length = 0;
}
